import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import QText from './QText';
import Logo from './Logo';
import { useTheme } from 'react-native-paper';

const LogoHeading = ({ heading, subHeading, showLogo, showAppTitle }) => {
  const theme = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  return (
    <View style={styles.logoContainer}>
      <>
        {showLogo && <Logo />}
        {heading && (
          <QText style={styles.headingTxt}>
            {`${heading} `}
            {showAppTitle && (
              <QText style={[styles.headingTxt, { fontWeight: 'bold' }]}>
                WaitKyu App
              </QText>
            )}
          </QText>
        )}
        {subHeading && (
          <QText style={styles.subHeadingWrapper}>{subHeading}</QText>
        )}
      </>
    </View>
  );
};

LogoHeading.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  showLogo: PropTypes.bool,
  showAppTitle: PropTypes.bool,
};

LogoHeading.defaultProps = {
  heading: '',
  subHeading: '',
  showLogo: true,
  showAppTitle: true,
};

const createStyles = (theme) =>
  StyleSheet.create({
    logoContainer: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    headingTxt: {
      fontSize: 20,
      fontWeight: 600,
      color: theme.colors.secondaryText,
      textAlign: 'center',
    },
    subHeadingWrapper: {
      marginVertical: 10,
      textAlign: 'center',
    },
  });

export default memo(LogoHeading);
